import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiResponse } from '@shared/models/api-response.model';
import { ICrudService } from '@shared/models/crud-service.model';
import { Sociedad } from '@shared/models/sociedad.model';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SociedadService implements ICrudService<Sociedad> {
  API: string = environment.API_URL;
  ruta: string = '/sociedad';
  _http: HttpClient = inject(HttpClient);

  save(item: Sociedad): Observable<Sociedad> {
    return this._http
      .post<ApiResponse<Sociedad>>(`${this.API}${this.ruta}`, item)
      .pipe(map(({ value }) => value));
  }

  update(item: Sociedad): Observable<Sociedad> {
    return this._http
      .put<ApiResponse<Sociedad>>(`${this.API}${this.ruta}`, item)
      .pipe(map(({ value }) => value));
  }

  findOne(item: Sociedad): Observable<Sociedad> {
    const params = new HttpParams().appendAll(item);
    return this._http
      .get<ApiResponse<Sociedad>>(`${this.API}${this.ruta}/BuscarUno`, {
        params,
      })
      .pipe(map(({ value }) => value));
  }

  findFor(item: Sociedad): Observable<Sociedad[]> {
    const params = new HttpParams().appendAll(item);
    return this._http
      .get<ApiResponse<Sociedad[]>>(`${this.API}${this.ruta}/BuscarPor`, {
        params,
      })
      .pipe(map(({ value }) => value));
  }

  findAll(): Observable<Sociedad[]> {
    return this._http
      .get<ApiResponse<Sociedad[]>>(`${this.API}${this.ruta}`)
      .pipe(map(({ value }) => value));
  }
}
